// extracted by mini-css-extract-plugin
export var button = "styles-module--button--6d829";
export var container = "styles-module--container--3aad3";
export var left = "styles-module--left--fc9ac";
export var progressbar = "styles-module--progressbar--3c030";
export var right = "styles-module--right--e40dd";
export var slider = "styles-module--slider--212ce";